import { Controller } from "@hotwired/stimulus"

// Auto-dismissing toast (8s) with manual dismiss.
export default class extends Controller {
  connect() {
    this.timer = setTimeout(() => this.dismiss(), 8000)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  dismiss() {
    this.element.remove()
  }
}
